// 공용 폴리필: Array.prototype.at, findLast, findLastIndex
// 클라이언트와 서버 양쪽에서 실행됨
export default defineNuxtPlugin({
  name: 'polyfills',
  enforce: 'pre',
  setup() {
    if (!(Array.prototype as any).at) {
      function at(this: Array<unknown> | string, n: number) {
        const i = Math.trunc(n) || 0
        // @ts-ignore
        const length = this.length
        const idx = i < 0 ? i + length : i
        // @ts-ignore
        return (idx < 0 || idx >= length) ? undefined : this[idx]
      }
      const TypedArray = Reflect.getPrototypeOf(Int8Array)
      for (const C of [Array, String, TypedArray].filter((c): c is FunctionConstructor => c != null && 'prototype' in c)) {
        Object.defineProperty(C.prototype, 'at', {
          value: at,
          writable: true,
          enumerable: false,
          configurable: true
        })
      }
    }

    // findLast
    if (!(Array.prototype as any).findLast) {
      Object.defineProperty(Array.prototype, 'findLast', {
        value: function <T>(this: Array<T>, predicate: (value: T, index: number, obj: Array<T>) => boolean, thisArg?: unknown) {
          if (this == null) throw new TypeError('Array.prototype.findLast called on null or undefined')
          if (typeof predicate !== 'function') throw new TypeError('predicate must be a function')
          const obj = Object(this) as Array<T>
          const len = obj.length >>> 0
          for (let i = len - 1; i >= 0; i--) {
            const value = obj[i]
            if (predicate.call(thisArg, value, i, obj)) return value
          }
          return undefined
        },
        writable: true,
        configurable: true,
        enumerable: false
      })
    }

    // findLastIndex
    if (!(Array.prototype as any).findLastIndex) {
      Object.defineProperty(Array.prototype, 'findLastIndex', {
        value: function <T>(this: Array<T>, predicate: (value: T, index: number, obj: Array<T>) => boolean, thisArg?: unknown) {
          if (this == null) throw new TypeError('Array.prototype.findLastIndex called on null or undefined')
          if (typeof predicate !== 'function') throw new TypeError('predicate must be a function')
          const obj = Object(this) as Array<T>
          const len = obj.length >>> 0
          for (let i = len - 1; i >= 0; i--) {
            const value = obj[i]
            if (predicate.call(thisArg, value, i, obj)) return i
          }
          return -1
        },
        writable: true,
        configurable: true,
        enumerable: false
      })
    }

    // document.hasStorageAccess (Storage Access API) polyfill for older browsers (e.g., Chrome 109 on Win7)
    // iframe 내의 document에서도 동작하도록 prototype에 정의
    if (import.meta.client && typeof Document !== 'undefined') {
      try {
        if (!Document.prototype.hasStorageAccess) {
          // @ts-ignore
          Document.prototype.hasStorageAccess = function() {
            return Promise.resolve(false)
          }
        }
        // 같이 세트로 쓰이는 requestStorageAccess도 혹시 몰라 추가
        if (!Document.prototype.requestStorageAccess) {
          // @ts-ignore
          Document.prototype.requestStorageAccess = function() {
            return Promise.resolve(false)
          }
        }
      } catch (e) {
        console.error('Failed to polyfill Storage Access API on Document.prototype:', e)
        // 만약 prototype 수정이 막혀있을 경우를 대비한 fallback
        if (typeof document !== 'undefined' && !document.hasStorageAccess) {
          // @ts-ignore
          document.hasStorageAccess = () => Promise.resolve(false)
        }
      }
    }
  }
})

